module.exports = __webpack_public_path__ + "static/media/location8.c6c76b23.webp";